import React from 'react'
import { Loader } from 'semantic-ui-react'

export const DataLoader = props => (
  <div style={{ padding: '1rem 0 3rem 0' }} {...props}>
    <Loader active inline="centered" content="Cargando datos" />
  </div>
)
